import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

import { ContactPerson } from '@ordersnproducts/modules/order-builder/modules/location-specification/models/order-management/contact-person.model';
import * as fromReceivingPersonsAction from '@ordersnproducts/modules/order-builder/modules/location-specification/actions/receiving-persons.action';
import { RESET_BUILDER } from '@ordersnproducts/modules/order-builder/actions/order-builder.actions';
import * as locationSpecificationAction from '../actions/location-specifications.actions';

export interface State extends EntityState<ContactPerson> {
  selectedContactPersonId: number | null;
}

export const adapter: EntityAdapter<ContactPerson> = createEntityAdapter<ContactPerson>({
  selectId: ($contactPerson: ContactPerson) => $contactPerson.contactId,
  sortComparer: false,
});

const initialState: State = adapter.getInitialState({
  selectedContactPersonId: undefined,
});

export function reducer(
  state = initialState,
  action: fromReceivingPersonsAction.Actions | locationSpecificationAction.LocationSpecificationActions,
): State {
  switch (action.type) {
    case RESET_BUILDER: {
      return {
        ...initialState,
      };
    }
    case fromReceivingPersonsAction.ActionTypes.FETCH_CONTACTS: {
      return state;
    }
    case fromReceivingPersonsAction.ActionTypes.STORE_CONTACTS: {
      const selectedId = state.selectedContactPersonId;
      state = adapter.addMany(action.payload, adapter.removeAll(state));
      state.selectedContactPersonId = selectedId;
      return state;
    }
    case fromReceivingPersonsAction.ActionTypes.ADD_NEW_CONTACT: {
      return adapter.addOne(action.payload, state);
    }
    case fromReceivingPersonsAction.ActionTypes.CLEAR_CONTACTS: {
      return adapter.removeAll(state);
    }
    case fromReceivingPersonsAction.ActionTypes.SELECT_CONTACT: {
      return { ...state, selectedContactPersonId: action.payload };
    }
    case locationSpecificationAction.LocationSpecificationActionTypes.SET_LOCATION_SPECIFICATION_FROM_MODIFY: {
      const receivingPersonState = action.payload.receivingPersons;
      return {
        ...receivingPersonState,
      };
    }
    default: {
      return state;
    }
  }
}

export const getSelectedContactPersonId = ($state: State) => $state.selectedContactPersonId;

export const getPersonsEntities = (state: State) => state.entities;

export const getContactPersons = (state: State) => {
  const contacts: ContactPerson[] = Object.keys(state.entities).map(i => state.entities[i]);
  return contacts;
};
